export function authHeader() {
    // return authorization header with jwt token
    let JWTToken = JSON.parse(localStorage.getItem('SessionToken'));
    if (JWTToken) {
        return { 'Authorization': 'Bearer ' + JWTToken };
    } else {
        return {};
    }
}